<template>
  <!-- 使用 v-if 控制显示隐藏，当 isShow 为 true 时渲染 -->
  <div v-if="isShow" class="v-required-hint" :class="customClass" role="alert">
    <!-- 默认插槽：允许外部自定义复杂内容（如带图标、链接的提示） -->
    <slot>
      <span class="v-required-hint__text">{{ message }}</span>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'RequiredHint',
  props: {
    // 控制提示显示/隐藏
    isShow: {
      type: Boolean,
      default: false
    },
    // 默认提示文案，当未提供插槽时生效
    message: {
      type: String,
      default: '此项为必填项'
    },
    // 允许外部传入自定义 CSS 类，用于覆盖样式
    customClass: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
/* 基础样式：红色警示文字，适合放在输入框下方 */
.v-required-hint {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.4;
  color: #f56c6c;
}

/* 可选：增加小图标的视觉提示（可通过插槽自由替换，这里仅作示例） */
.v-required-hint__text::before {
  content: '⚠ ';
  font-weight: normal;
}
</style>